/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { TextInput } from 'carbon-components-react';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl, FormattedMessage } from 'react-intl';

import { selectTargetEnvironmentId } from '@ibm-watson/shared/modules/ia/store/environments/selectors';
import { useAppSelector } from '@ibm-watson/shared/store';
import { useChannelHelpers } from '../../../hooks/useChannelHelpers';
import { TabContent } from '../../common/tabbed-header/TabContent';
import { FIELDS } from '../schema';
import { SelectEventsTab } from '../select-events-tab/SelectEventsTab';
import { ConfigDetailsMessages as messages } from './messages';

import './ConfigurationDetailsTab.scss';

interface ConfigurationDetailsTabProps {
  environmentId: string;
  readOnly: boolean;
  tabname: string;
}
export const ConfigurationDetailsTab = ({
  environmentId,
  readOnly
}: ConfigurationDetailsTabProps) => {
  const { formatMessage: t } = useIntl();

  const formMethods = useFormContext();
  const { useValidSegmentKey } = useChannelHelpers(formMethods);

  const isLive = useAppSelector(state => {
    const liveEnvironmentId = selectTargetEnvironmentId(state);
    return liveEnvironmentId === environmentId;
  });

  return (
    <TabContent
      className="ConfigurationDetailsTab"
      title={<FormattedMessage {...messages.title} />}>
      <div className="ConfigurationDetailsTab__step">
        <TextInput
          className="ConfigurationDetailsTab__segment-key-input"
          disabled={readOnly}
          id="ConfigurationDetailsTab__key"
          labelText={t(messages.segmentKey)}
          {...useValidSegmentKey(FIELDS.SEGMENT_WRITE_KEY, readOnly)}
        />
      </div>
      <SelectEventsTab isLive={isLive} readOnly={readOnly} />
    </TabContent>
  );
};
